module.exports = __webpack_public_path__ + "img/18.d62b0130.jpg";